import OpenAgreement from '../[ctypk]/[category]/[id]';
export default OpenAgreement;